import { useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { ROLES } from '@/config/roles'

const RoleRedirectHandler = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const hasRedirected = useRef(false)
  const { currentUser, userRole, loading } = useAuth()

  useEffect(() => {
    if (loading) return

    const currentPath = location.pathname

    // Don't redirect if already on role-select page
    if (currentPath === '/auth/role-select') {
      hasRedirected.current = false
      return
    }

    // Only redirect authenticated users with UNDEFINED role (string 'UNDEFINED')
    if (
      currentUser &&
      (userRole === ROLES.UNDEFINED || userRole === 'UNDEFINED') &&
      !hasRedirected.current
    ) {
      // Allow redirect even from login/register pages for new users
      hasRedirected.current = true
      navigate('/auth/role-select', { replace: true })
    } else if (
      currentUser &&
      userRole &&
      userRole !== ROLES.UNDEFINED &&
      userRole !== 'UNDEFINED'
    ) {
      // User has a defined role, reset redirect flag
      hasRedirected.current = false
    } else if (!currentUser) {
      hasRedirected.current = false
    }
  }, [currentUser, userRole, loading, navigate, location.pathname])

  return null
}

export default RoleRedirectHandler
